// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import './WizardSaveToast.css';

interface WizardSaveToastProps {
  visible: boolean;
  message?: string;
}

export function WizardSaveToast({ visible, message = 'Progress saved' }: WizardSaveToastProps) {
  return (
    <div
      className={`wizard-save-toast ${visible ? 'wizard-save-toast--visible' : ''}`}
      aria-live="polite"
      role="status"
    >
      {message}
    </div>
  );
}
